import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import IdentityUserKidTableHead from '../../components/molecules/IdentityUserKidTableHead';
import IdentityUserKidTableBody from '../../components/molecules/IdentityUserKidTableBody';
import IdentityUserKidApproval from './IdentityUserKidApproval';
import IdentityUserKidDetail from './IdentityUserKidDetail';
import { sendLogin } from '../../auth/Auth';
import ExPagination from '../../components/molecules/ExPagination';
import {
  getIdentityUserKidsDetail,
  GET_IDENTITY_USER_KIDS_DETAIL_SUCCESS
} from '../../actions/Identity';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      identityUserKid:
        state.identities && state.identities.identityUserKid
          ? state.identities.identityUserKid.list
          : [],
      totalCount:
        state.identities && state.identities.identityUserKid
          ? state.identities.identityUserKid.count
          : 0,
      offset:
        state.identities && state.identities.identityUserKid
          ? state.identities.identityUserKid.offset
          : 0
    }),
    dispatch => ({
      actions: bindActionCreators({ getIdentityUserKidsDetail }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openRegisterModal', 'updateOpenRegisterModal', false),
  withState('openApprovalModal', 'updateOpenApprovalModal', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState(
    'openApprovalConfirmModal',
    'updateOpenApprovalConfirmModal',
    false
  ),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('page', 'setPage', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('detail', 'setDetail', null),
  withState('userKidDetail', 'setUserKidDetail', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    actions,
    classes,
    roles,
    identityUserKid,
    searchKey,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    updateOpenRegisterModal,
    openApprovalModal,
    updateOpenApprovalModal,
    openApprovalConfirmModal,
    updateOpenApprovalConfirmModal,
    rowsPerPage,
    handleChangeRowsPerPage,
    targetRowId,
    setTargetRowId,
    order,
    orderBy,
    handleRequestSort,
    poorStatusArr,
    userKidStatusArr,
    detail,
    setDetail,
    openDetailModal,
    updateOpenDetailModal,
    userKidDetail,
    setUserKidDetail,
    updateLoading,
    updateOpenProgress,
    checkSession,
    setResultMessage
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    // const confirmOpenAction = userId => {
    //   identityUserKid.forEach(item => {
    //     if (item.userId === userId) {
    //       setDetail(item);
    //     }
    //   });
    //   updateOpenApprovalModal(true);
    // };

    const getIdentityUserDetail = async userId => {
      await actions.getIdentityUserKidsDetail(userId).then(detailData => {
        checkSession(detailData);
        if (detailData.type === GET_IDENTITY_USER_KIDS_DETAIL_SUCCESS) {
          const dataDetail = _.cloneDeep(detailData.payload);
          setDetail(dataDetail);
          updateOpenApprovalModal(true);
          updateOpenProgress(false);
        } else {
          setDetail(null);
          setResultMessage('エラーが発生しました。');
        }
        return detailData;
      });
    };

    const confirmOpenAction = userId => {
      updateLoading(true);
      updateOpenProgress(true);
      getIdentityUserDetail(userId)
        .then(() => {
          updateLoading(false);
        })
        .catch(() => {
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const openDetailUserKid = userId => {
      let detailUser = {};
      identityUserKid.forEach(element => {
        if (element.userId === userId) {
          detailUser = element;
        }
      });
      setUserKidDetail(detailUser);
      updateOpenDetailModal(true);
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <IdentityUserKidTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <IdentityUserKidTableBody
              identityUserKid={identityUserKid}
              emptyRows={emptyRows}
              page={page}
              orderBy={orderBy}
              order={order}
              rowsPerPage={rowsPerPage}
              confirmOpenAction={confirmOpenAction}
              updateOpenRegisterModal={updateOpenRegisterModal}
              updateOpenConfirmModal={updateOpenApprovalModal}
              setTargetRowId={setTargetRowId}
              roles={roles}
              poorStatusArr={poorStatusArr}
              userKidStatusArr={userKidStatusArr}
              openDetailUserKid={openDetailUserKid}
            />
          </Table>
        </div>
        {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
          <div>
            <ExPagination
              searchResults={identityUserKid}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalCount}
              offset={offset}
              selectedPage={selectedPage}
            />
          </div>
        )}
        <Modal open={openDetailModal}>
          <IdentityUserKidDetail
            updateOpenDetailModal={updateOpenDetailModal}
            detailUser={userKidDetail}
          />
        </Modal>
        <Modal open={openApprovalModal}>
          <IdentityUserKidApproval
            updateOpenApprovalModal={updateOpenApprovalModal}
            openApprovalConfirmModal={openApprovalConfirmModal}
            updateOpenApprovalConfirmModal={updateOpenApprovalConfirmModal}
            detail={detail}
            targetRowId={targetRowId}
            searchKey={searchKey}
            handleChangePage={handleChangePage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
